import { Add as AddIcon } from '@mui/icons-material';
import { CommonButton } from './CommonButton';

interface AddNoticeButtonProps {
  title: string;
  onAddClick: () => void;
}

export const AddNoticeButton = ({ title, onAddClick }: AddNoticeButtonProps) => {
  return (
    <CommonButton
      startIcon={<AddIcon />}
      onClick={onAddClick}
    >
      {title}
    </CommonButton>
  );
}; 